module.exports = __webpack_public_path__ + "assets/img/verification.fc415700.svg";